import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.307 3.307 16 16 3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M1.618 5.81c.22-.454.496-.949.842-1.446l.265.763 1.193.025-.95.72.345 1.143-.98-.682-.98.682.346-1.142zm.517 21.328c-.287-.47-.515-.925-.695-1.334l.501-.01.392-1.127.392 1.127 1.193.024-.95.721.345 1.143-.98-.682zM13 16.667l-.98.681.346-1.142-.951-.721 1.193-.024.392-1.128.392 1.128 1.193.024-.95.721.345 1.142zM5.334 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m4.333 12.333 1-1 1 1-.666 2.334H5zm3.235.6 1.406.148-.148 1.406-2.233.95-.42-.518zm2.314 4.11-.75-1.2-2.423.125-.15.65 2.124 1.174zm-2.056 1.82-.46 1.338-1.337-.46-.424-2.39.599-.292zm-4.525 1.338 1.337-.46.424-2.39-.6-.292-1.621 1.805zm-1.317-2.41-1.2-.748.75-1.2 2.424.125.15.65zm-.291-4.71.147 1.406 2.233.95.42-.518-1.394-1.986z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagPhl = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagPhl_default = SvgFlagPhl;

export { FlagPhl_default as default };
